
import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import IncentivePrograms from '@deere/cps-it.warranty-model-factory/lib/incentive-programs';
import IncentiveProgramsItem from './incentive-programs-item';

const IncentiveProgramsPanel = props => {

    const incentiveProgramsPanelTitle = (
        <div>
            <FormattedMessage id='INCENTIVE_PROGRAMS'/> {` (${props.incentivePrograms.length})`}
        </div>
    );

    const incentiveProgramsPanelBody = props.incentivePrograms.map((incentiveProgram, i) =>
        <IncentiveProgramsItem
            incentiveProgram={incentiveProgram}
            key={i}
            pin={props.pin}

        />
    );

    return (

        <Accordion
            accordionId='incentive-programs-panel-accordion'
            body={incentiveProgramsPanelBody}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            title={incentiveProgramsPanelTitle}
        />

    );

};

IncentiveProgramsPanel.displayName = 'IncentiveProgramsPanel';
IncentiveProgramsPanel.propTypes = {
    incentivePrograms: PropTypes.arrayOf(PropTypes.instanceOf(IncentivePrograms)).isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired
};

export default IncentiveProgramsPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/incentive-programs-panel.js